  <template>
  <div style="position: relative;">
    <div class="overlay-staff-row" v-if="getExpandId != -1 && getExpandId != item.id"></div>
    <div class="event-row">
      <div class="column" :style="{'width': columnWidth.firstName.size ? (columnWidth.firstName.size + 'px') : '10%'}">
        <div class="content padding-left-27px">
          <input class="input-staff" type="text" v-model="item.firstName" title="first name"
                 v-if="item.isEditing || isEditing" placeholder="First Name"/>
          <span v-if="!(item.isEditing || isEditing)">{{item.firstName}}</span>
        </div>
      </div>
      <div class="column" :style="{'width': columnWidth.lastName.size ? (columnWidth.lastName.size + 'px') : '10%'}">
        <div class="content">
          <input class="input-staff" type="text" v-model="item.lastName" title="last name"
                 v-if="item.isEditing || isEditing" placeholder="Last Name"/>
          <span v-if="!(item.isEditing || isEditing)">{{item.lastName}}</span>
        </div>
      </div>
      <div class="column" :style="{'width': columnWidth.email.size ? (columnWidth.email.size + 'px') : '16%'}">
        <div class="content">
          <input class="input-staff" type="text" v-model="item.email" title="email" v-if="item.isEditing || isEditing" placeholder="Email"/>
          <span v-if="!(item.isEditing || isEditing)">{{item.email}}</span>
        </div>
      </div>
      <div class="column"
           :style="{'width': columnWidth.phoneNumber.size ? (columnWidth.phoneNumber.size + 'px') : '8%'}">
        <div class="content">
          <the-mask mask="(###) ###-####" v-model="item.phone" class="input-staff"
                    :class="{'no-border': !(item.isEditing || isEditing)}"
                    placeholder="Phone Number" :disabled="!(item.isEditing || isEditing)"></the-mask>
        </div>
      </div>
      <click-outside :handler="hideSelectRole">
        <div class="column select-role" :style="{'width': columnWidth.role.size ? (columnWidth.role.size + 'px') : '14%'}">
          <div class="content"> <!-- @click="showSelectRole()"-->
            <span :class="{'placeholder-color': !item.role}">{{getRolesShow()}}</span>
          </div>
          <div class="role-selector show-on-top" v-if="isSelectRole">
            <b-form-group>
              <b-form-checkbox-group id="checkboxes-role" name="roles" v-model="selectedRoles">
                <b-form-checkbox :id="item.id + '-lead'" value="lead">Lead</b-form-checkbox>
                <b-form-checkbox :id="item.id + '-screener'" value="screener">Screener
                </b-form-checkbox>
                <b-form-checkbox :id="item.id + '-concierge'" value="concierge">Concierge
                </b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </div>
        </div>
      </click-outside>
      <div class="column" :style="{'width': columnWidth.events.size ? (columnWidth.events.size + 'px') : '10%'}">
        <div class="content">
          <span>{{item.totalEvents}}</span>
        </div>
      </div>
      <div class="column" :style="{'width': columnWidth.payRates.size ? (columnWidth.payRates.size + 'px') : '8%'}">
        <div class="content">
          <input class="input-staff" type="text" v-model="item.payRates" title="Pay Rate"
                 v-if="item.isEditing || isEditing" placeholder="Pay Rate"/>
          <span v-if="!(item.isEditing || isEditing)">&#36; {{item.payRates || 0}}</span>
        </div>
      </div>
      <div class="column" :style="{'width': columnWidth.address.size ? (columnWidth.address.size + 'px') : '20%'}">
        <div class="content">
          <div v-if="isUsedBingMap && (item.isEditing || isEditing)" :id="'searchBoxStaffContainer-' + index">
            <label :for="'searchBoxStaff-' + index"></label>
            <input type="text" :id="'searchBoxStaff-' + index"
                   placeholder="Address"
                   v-model="item.address"
                   class="map-wrapper"/>
          </div>
          <vue-google-autocomplete name="address-input"
                                   v-if="!isUsedBingMap && (item.isEditing || isEditing)"
                                   :id="'map_' + index"
                                   classname="map-wrapper"
                                   :placeholder="item.address || 'Enter address'"
                                   v-on:placechanged="setPlace"
                                   :country="['us']" :item="item"
                                   v-on:change="getValue"></vue-google-autocomplete>
          <span v-if="!(item.isEditing || isEditing)">{{item.address}}</span>
        </div>
      </div>
      <div class="column col-group-btn-action" :style="{'width': columnWidth.actions.size ? (columnWidth.actions.size + 'px') : '4%'}">
        <div class="btn-func">
          <div class="btn-func-item">
            <div class="func-icon icon-info" @click="openStaffDetail(item)"></div>
          </div>
          <!--<div class="btn-func-item" @click="setEditStaff(item.id)">
            <div class="func-icon icon-edit"></div>
          </div>
          <div class="btn-func-item" @click="deleteStaff(item.id)">
            <div class="func-icon icon-delete"></div>
          </div>-->
        </div>
      </div>
    </div>
    <div class="displayNone" :class="{'openContent': item.id == getExpandId}">
      <div class="dt-row-item-detail">
        <div class="row">
          <div class="col-sm-12 text-right margin-top-10px">
            <b-button class="ap-btn secondary" @click="cancelSave()">
              cancel
            </b-button>
            <b-button class="ap-btn primary" @click="saveStaff()" :disabled="!canSave">
              save
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import 'vue-awesome/icons/ellipsis-v';
  import Icon from 'vue-awesome/components/Icon';
  import {mapMutations, mapGetters, mapActions} from 'vuex';
  import VueGoogleAutocomplete from 'vue-google-autocomplete';
  import {TheMask} from '../utils/vue-the-mask';
  import * as _ from 'lodash';
  import ClickOutside from 'onclick-outside';
  // import constants from '../../_consts';

  export default {
    name: 'event-row',
    components: {
      Icon,
      VueGoogleAutocomplete,
      TheMask,
      ClickOutside
    },
    props: {
      index: {
        type: Number,
        default: 0
      },
      item: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        checkedConcierge: false,
        checkedLead: false,
        checkedScreener: false,
        isLoading: false,
        isDisplay: false,
        editable: false,
        isLocked: false,
        showOnModal: false,
        editEventAdmin: false,
        viewMode: false,
        suggestChanges: false,
        isEditing: false,
        tempStaff: {},
        canSave: false,
        selectedRoles: [],
        roleOptions: [
          {text: 'lead', value: 'lead'},
          {text: 'screener', value: 'screener'},
          {text: 'concierge', value: 'concierge'}
        ],
        isSelectRole: false
      }
    },
    computed: {
      isUsedBingMap () {
        return process.env.IS_BING_MAP === 'true';
      },
      ...mapGetters({
        getExpandId: 'GETTERS_GET_EXPAND_ID',
        columnWidth: 'GETTER_GET_COLUMN_TABLE_STAFFING'
      })
    },
    methods: {
      setEditStaff () {
        this.isEditing = true;
        this.tempStaff = _.clone(this.item);
        if (this.getExpandId !== this.item.id) {
          this.setIdToState(this.item.id);
        }
        if (this.isUsedBingMap) {
          window.Microsoft.Maps.loadModule('Microsoft.Maps.AutoSuggest', {
            callback: this.onLoadBingSuggest,
            errorCallback: this.onErrorBingSuggest
          });
        }
      },
      openStaffDetail (item) {
        this.setStaffDetailForNavigation(item);
        this.$modal.show('staffDetailModal', item);
      },
      cancelSave () {
        this.isEditing = false;
        this.item = _.clone(this.tempStaff);
        this.item.isEditing = false;
        this.setIdToState(this.item.id || 0);
        let roleString = this.item.role || '';
        this.selectedRoles = (roleString.replace(/\s/g, '').split(',')) || [];
      },
      saveStaff () {
        if (!this.item.email.match(/\S+@\S+\.\S+/)) {
          this.$toastr('error', 'Email has invalid format!', '');
          return;
        }
        this.callApiCreateStaff(this.item).then((response) => {
          if (!response.message) {
            this.isEditing = false;
            this.item.isEditing = false;
            this.setIdToState(this.item.id);
            // this.$emit('getListStaff');
          } else {
            this.$toastr('error', response.message, '');
          }
        });
      },
      deleteStaff () {
        this.$swal({
          title: "<div class='ems_alert_title'>delete staff</div>",
          html: `<div class='ems_alert_des'>Are you sure to delete?</div>`,
          confirmButtonColor: '#0080A5',
          confirmButtonText: 'DELETE',
          showCancelButton: true,
          cancelButtonColor: '#fff',
          cancelButtonText: 'CANCEL',
          buttonsStyling: true,
          reverseButtons: true,
          confirmButtonClass: 'ems_alert_confirm open',
          cancelButtonClass: 'ems_alert_cancel',
          customClass: 'ems_confirm',
          allowOutsideClick: false,
          allowEscapeKey: false,
          width: 605
        }).then((result) => {
          if (result.value) {
            if (this.item.id === 0) {
              this.$emit('getListStaff');
              return;
            }
            this.callApiDeleteStaff(this.item).then((response) => {
              if (!response.message) {
                this.$emit('getListStaff');
              }
            });
          }
        });
      },
      showSelectRole () {
        this.isSelectRole = true;
        this.isEditing = true;
        this.tempStaff = _.clone(this.item);
        if (this.getExpandId !== this.item.id) {
          this.setIdToState(this.item.id);
        }
        let roleString = this.item.role || '';
        this.selectedRoles = roleString.length > 0 ? (roleString.replace(/\s/g, '').split(',')) : [];
      },
      getRolesShow () {
        return this.item.role ? this.item.role.replace(/,/g, ', ') : 'Select roles';
      },
      hideSelectRole () {
        this.isSelectRole = false;
        this.item.role = this.selectedRoles.join(',');
      },
      toggleRole (role) {
        console.log(role + ' -- item role: ' + this.item.role);
        let roleString = this.item.role || '';
        let roleArr = roleString.length > 0 ? (roleString.replace(/\s/g, '').split(',')) : [];
        let index = roleArr.indexOf(role);
        if (index >= 0) {
          roleArr.splice(index, 1);
        } else {
          roleArr.push(role);
        }
        this.item.role = roleArr.join(', ');
      },
      checkIsRole (role) {
        let checked = (this.item && this.item.role && this.item.role.indexOf(role) >= 0);
        console.log(role + ' -- item check role: ' + this.item.role + ' ischeck:' + checked);
        return checked;
      },
      onLoadBingSuggest () {
        let options = { maxResults: 5 };
        setTimeout(() => {
          (new window.Microsoft.Maps.AutosuggestManager(options)).attachAutosuggest('#searchBoxStaff-' + this.index, '#searchBoxStaffContainer-' + this.index, this.selectedAddressFromBing);
        }, 1000)
      },
      onErrorBingSuggest (error) {
        console.log('error=', error);
      },
      // START BING MAP SECTION
      selectedAddressFromBing (obj) {
        let addressDetail = obj.address;
        if (!addressDetail.adminDistrict || !addressDetail.locality || !addressDetail.postalCode) {
          this.$toast.success('Please enter a complete address including city and state or zip code', '', {
            ...this.$toastOpt.optError
          });
          return;
        }
        this.item.address = addressDetail.formattedAddress;
      },
      // START GOOGLE MAP SECTION
      setPlace (data, place) {
        this.item.address = place.formatted_address;
      },
      ...mapActions({
        callApiCreateStaff: 'ACTION_CREATE_STAFF',
        callApiDeleteStaff: 'ACTION_DELETE_STAFF'
      }),
      ...mapMutations({
        setIdToState: 'MUTATION_SET_EXPAND_ID',
        setStaffDetailForNavigation: 'MUTATION_SET_STAFF_DETAIL'
      })
    },
    mounted () {
      if (this.isUsedBingMap) {
        if (window.Microsoft.Maps.AutosuggestManager == null) {
          window.Microsoft.Maps.loadModule('Microsoft.Maps.AutoSuggest', {
            callback: this.onLoadBingSuggest,
            errorCallback: this.onErrorBingSuggest
          });
        } else {
          this.onLoadBingSuggest();
        }
      }
      this.canSave = (this.item.firstName && this.item.lastName && this.item.email && this.item.phone && this.item.role && this.item.payRates && this.item.address);
      let roleString = this.item.role || '';
      this.selectedRoles = roleString.length > 0 ? (roleString.replace(/\s/g, '').split(',')) : [];
    },
    watch: {
      item: {
        handler (item) {
          this.canSave = (this.item.firstName && this.item.lastName && this.item.email && this.item.phone && this.item.role && this.item.payRates && this.item.address);
        },
        deep: true
      }
    }
  }
</script>

<style lang="less" scoped="">
  @import '../../styles/variables.less';
  .map-wrapper {
    font-family: @font-family-main;
    border: 0 solid @grey-4;
    border-radius: 3px;
    width: 100%;
    min-height: 0;
    z-index: unset;
    height: 19px;
    color: #1D1D1D;
    font-size: 12px;
    line-height: 19px;
  }
  .event-row-wrapper {
    margin: 8px 0;

    &:last-child{
      .event-row{
        .show-on-top{
          position: absolute;
          bottom: 24px;
          left: 0;
        }
      }
    }
  }
  .overlay-staff-row {
    position: absolute;
    background: black;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 998;
    opacity: 0.02;
  }

  .openContent {
    height: 50px !important;
    transition: height ease 0.5s;
    .dt-row-item-detail {
      clear: both;

      .ap-btn{
        padding: 6px 24px;
      }

      .item-detail-header {
        text-transform: uppercase;
        font-size: 12px;
        line-height: 16px;
        border-bottom: solid 1px @grey-2;
        height: 34px;
        background-color: @grey-1;
        font-family: "Open Sans";
        color: @white;
        letter-spacing: 0.1px;
      }
      .item-detail-body {
        background-color: @white;
        padding: 20px 10px 15px 20px;
        height: 314px;
        .row-detail-icon-exclamation-circle {
          height: 14px;
          width: 14px;
          border-radius: 6px;
          padding: 0;
          color: @blue;
          background-color: @white;
          overflow: visible;
        }
        .icon-alert {
          padding: 2px 0 0 22px;
        }
        .text-alert {
          font-family: @font-family-main;
          font-size: 12px;
          padding: 0 20px 0 15px;
          color: @black-2;
          .alert-note {
          }
        }
        .notes-field {
          margin-top: 20px;
          &:first-child {
            margin-top: 0;
          }
          .text-label {
            font-size: 12px;
            text-transform: capitalize;
            line-height: 18px;
            font-family: @font-family-main;
            color: @grey-8;
            .label-address {
              color: @grey-8;
            }
          }
          .text-value {
            .shipping-address {
              width: 100%;
              border: solid 1px @grey-3;
              border-radius: 4px;
              height: 32px;
              font-size: 12px;
              font-family: @font-family-main;
              color: @grey-8;
              padding-left: 16px;
            }
            textarea {
              width: 100%;
              border-radius: 4px;
              border: solid 1px @grey-3;
              padding: 5px 10px;
              &.custom-notes {
                height: 55px;
                padding-left: 14px;
                color: @black;
              }
              &.additional-comments {
                height: 58px;
                padding-left: 14px;
                font-size: 12px;
                font-family: @font-family-main;
                color: @grey-8;
              }
            }
          }
        }
        .text-contact {
          margin-bottom: 20px;
          margin-right: 10px;
          .phoneAndEmail {
            height: 32px;
            width: 100%;
            border: 1px solid @grey-3;
            border-radius: 4px;
            font-family: @font-family-main;
            padding: 0 0 0 13px;
            font-size: 12px;
            color: @grey-8;
          }
          .label {
            color: @black-1;
            font-family: @font-family-main;
            font-size: 12px;
            text-transform: capitalize;
            line-height: 18px;
          }
          .contactName {
            line-height: 31px;
          }
        }
        .add-on-off-text {
          color: @grey-4 !important;
        }
        .add-on-off-checkbox {
          border: 1.5px solid rgba(0, 0, 0, 0.02) !important;
        }
        .add-on-off-checkbox:after {
          border: 1.5px solid rgba(0, 0, 0, 0.02) !important;
        }
        .add-on-wrapper {
          .add-on-item {
            margin-left: 0;
            margin-top: 8px;
            .text {
              color: @black-2;
              font-family: "Open Sans";
              font-size: 12px;
              display: inline;
              margin-left: 5px;
            }
            input[type=checkbox] {
              height: 0;
              width: 0;
              visibility: hidden;
            }
            label {
              cursor: pointer;
              text-indent: -9999px;
              width: 32px;
              height: 18px;
              background: @white;
              border-radius: 15.5px;
              position: relative;
              top: 1.5px;
              left: 5px;
              border: 1.5px solid rgba(0, 0, 0, 0.1);
              margin-bottom: 0;
            }

            label:after {
              content: '';
              position: absolute;
              top: -0.5px;
              left: -0.5px;
              width: 16px;
              height: 16px;
              background: @white;
              border-radius: 15.5px;
              -webkit-transition: 0.3s;
              transition: 0.3s;
              border: 0.5px solid rgba(0, 0, 0, 0.1);

            }

            input:checked + label {
              background: @blue;
              border: 1.5px solid @blue;
              // border: none;
            }

            input:checked + label:after {
              // top: -0.5px;
              left: calc(100% - 0px);
              transform: translateX(-100%);
              box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);
            }

            label:active:after {
              width: 15px;
            }
          }
        }
        .func-group {
          button {
            font-size: 14px;
            height: 39px;
            font-family: @font-family-main;
            text-transform: uppercase;
            .func-icon {
              width: 18px;
              height: 18px;
              color: @white;
              float: left;
            }
          }
          .grey-3 {
            color: @grey-3;
          }
        }
      }
    }
  }

  .displayNone {
    height: 0;
    overflow: hidden;
    transition: height ease 0.5s;
  }

  .event-row {
    height: 56px;
    background-color: @white;
    border-radius: 4px;
    box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);
    color: @black-3;
    font-family: @font-family-main;
    font-size: 12px;
    line-height: 16px;
    position: relative;
    .column {
      float: left;
      background-color: @white;
      border-radius: 4px;
      height: 100%;
      align-items: center;
      display: flex;
      padding-left: 8px;

      &.col-group-btn-action{
        padding: 0 0 0 8px;
      }

      .content {

        &.column-name {
          padding: 12px 0 0 8px;
        }

        &.paddingTop5px {
          padding-top: 5px;
        }
        .input-staff{
          width: 100%;
          max-width: 100%;
          border: none;
          color: @black-3;
          font-size: 12px;
          background-color: @white;

          &:disabled{
            background-color: @white;
            color: @black-3;
            font-size: 12px;
          }
        }

        .placeholder-color{
          color: @grey-3;
        }
      }
    }
    .btn-func {

      .btn-func-item {
        float: left;
        background-color: @light-blue;
        border-radius: 4px;
        height: 32px;
        width: 32px;
        margin-left: 6px;
        &.btn-func-item:first-child {
          margin-left: 0;
        }
        .func-icon {
          width: 26px;
          height: 26px;
          // color: @white;
          // background-color: @white;
          margin: 4px auto;

          &:hover {
            cursor: pointer;
          }

          &.icon-info {
            background: url('../../../static/img/status-information-white.svg') no-repeat center;
            // -webkit-mask: url('../../../static/img/status-information.svg') no-repeat center;
            // mask: url('../../../static/img/status-information.svg') no-repeat center;
          }
          &.icon-edit {
            background: url('../../../static/img/edit-pencil-white.svg') no-repeat center;
            // -webkit-mask: url('../../../static/img/edit-pencil.svg') no-repeat center;
            // mask: url('../../../static/img/edit-pencil.svg') no-repeat center;
          }
          &.icon-delete {
            background: url('../../../static/img/action-trash-white.svg') no-repeat center;
            // -webkit-mask: url('../../../static/img/action-trash.svg') no-repeat center;
            // mask: url('../../../static/img/action-trash.svg') no-repeat center;
          }

          @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
            &.icon-info {
              background: url('../../../static/img/status-information-white.svg') no-repeat center;
            }

            &.icon-edit {
              background: url('../../../static/img/edit-pencil-white.svg') no-repeat center;
            }

            &.icon-delete {
              background: url('../../../static/img/action-trash-white.svg') no-repeat center;
            }
          }
        }
      }
    }
    .select-role {
      text-transform: capitalize;
      position: relative;
      height: 56px;

      /* &:hover {
        cursor: pointer;
      }*/
    }
    .role-selector {
      position: absolute;
      width: 115px;
      background: @white;
      padding: 16px;
      z-index: 999;
      border-radius: 4px;
      line-height: 25px;
      height: 112px;
      box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.15), 0 9px 7px 1px rgba(0, 0, 0, 0.1);
      margin-top: 28px;
    }
  }

  .MicrosoftMap {
    &.as_container_search {
      width: 250px;
    }
  }

  .li-red {
    &:before {
      color: @red !important;
    }
  }

  .padding-left-71 {
    padding-left: 71px;
  }

  .padding-left-27 {
    padding-left: 27px;
  }

  .padding-top-9px {
    padding-top: 9px;
  }
</style>



// WEBPACK FOOTER //
// StaffingRow.vue?4539e988